import axios from "axios";

const { REACT_APP_TACHO_API } = process.env;

export const getTachoDownloads = async (customer, page, results_per_page, filters = "") => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_TACHO_API}/${customer}/tacho_downloads`,
      params: {
        page,
        results_per_page,
        filters,
      },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data };
  } catch (e) {
    return { details: e.response.data.details };
  }
};

